import { Button, Column, Columns, Detail, Flex } from "@dna/react";
import { FormControl, Box, TextField } from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { useAsync } from "../common/async";
import styles from "./SelectOrganisation.module.scss";
import { organisationService } from "../../services/organisation/OrganisationApi";
import { LoadingPlaceholder } from "@communicare/medications/Components/Placeholder";
import cx from 'classnames';
import { MessageType } from "../common/constants";
import { MapExternalUserMessageBox } from "./MapExternalUserMessageBox";

export function LinkAdditionalOrganisation<T>(props: {onClose: any}) {
  let { inProgress, success, error, queryDispatcher } = useAsync();
  const [organisationNames, setOrganisationNames] = useState([]);
  const redirectToResidents = () => {
    window.location.href = window.location.origin + "/residents";
  };

  useEffect(() => {
    if (!success) {
      queryDispatcher(organisationService.linkToAdditionalOrganisations().then(result => {
           setOrganisationNames(result.organisationList);
      }));
    }
  }, []);

  if (inProgress) {
    return (
        <div className={styles.spinnerBackground}>
         <div className={styles.inner}>
          <Box
             className={cx(styles.content, styles.marginTop100)}
             css={{
              width: 50,
              height: 50,
            }}
          >
            <LoadingPlaceholder size={30} />
          </Box>
        </div> 
        </div>
    );
  }

  if (error) {
    return (
      <div >
        <FormControl className={styles.dialogWidth}>
          <Flex
            css={{
              gap: "small",
              padding: 0,
            }}
          >
            {
              <MapExternalUserMessageBox 
              type={MessageType.Warning} 
              titleText="We can't find you." 
              bodyText="Please review your details or contact the aged care facility." 
              isRegistrationForm={false}
              onClose={props.onClose} />
            }
       </Flex>
        </FormControl>
      </div>
 
    );
  }
    return (
        <div>
          <FormControl className={styles.dialogWidth}>
            <Flex
              css={{
                gap: "small",
                padding: 0,
              }}
            >
        {
        <MapExternalUserMessageBox 
        type={MessageType.Success} 
        titleText="We found you!" 
        bodyText="You can now access your residents at..." 
        organisationNames={organisationNames}
        redirectToHome = {redirectToResidents}
        isRegistrationForm={false} />
        }
            </Flex>
          </FormControl>
        </div>
    
    );
}
